import api from './api';

// Grade Watch API (Phase 2). The axios `api` client attaches the auth token and
// routes tier-limit 403s to the global LimitReachedModal automatically.
export const getWatchlist = () =>
  api.get('/grade-watch/watchlist').then((r) => r.data);

export const addWatch = (symbol) =>
  api.post('/grade-watch/watch', { symbol }).then((r) => r.data);

export const removeWatch = (symbol) =>
  api.delete(`/grade-watch/watch/${encodeURIComponent(symbol)}`).then((r) => r.data);
